import React, { Component } from 'react';
import { Link, animateScroll as scroll} from 'react-scroll';

class Nav extends Component {
  render() {
    return (
      <nav>
        <ul>
            <li className="logo" onClick={()=> scroll.scrollToTop()}></li>
        </ul>
        <ul >
            <li><Link to="cabeza" spy={true} smooth={true} offset={0} duration={5000} style={{cursor:'pointer'}}>Inicio</Link></li>
            <li><Link to="acerca" spy={true} smooth={true} offset={0} duration={5000} style={{cursor:'pointer'}}>Acerca</Link></li>
            <li><Link to="mision" spy={true} smooth={true} offset={0} duration={5000} style={{cursor:'pointer'}}>Misión</Link></li>
            <li><Link to="servicios" spy={true} smooth={true} offset={0} duration={5000} style={{cursor:'pointer'}}>Servicios</Link></li>
            <li><Link to="galeria" spy={true} smooth={true} offset={0} duration={5000} style={{cursor:'pointer'}}>Galería</Link></li>
            <li><Link to="contacto" spy={true} smooth={true} offset={0} duration={5000} style={{cursor:'pointer'}}>Contacto</Link></li>
        </ul>
     </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/nav.js